export const OAuthSettings = {
  appId: 'b14a83d2-dcc3-44c0-862e-83d3eb30cb34',
  scopes: [
    "user.read"
  ],
  authority: 'https://login.microsoftonline.com/82dc4196-9dae-4650-9555-05bccddbfd01'  
};
//'https://login.microsoftonline.com/common'
//https://login.microsoftonline.com/82dc4196-9dae-4650-9555-05bccddbfd01
//b9938f60-9882-4c87-af5f-37918cce387e
//Application with identifier '2638b4c9-94e1-4776-addb-72ee74e75933' was not found in the directory '82dc4196-9dae-4650-9555-05bccddbfd01'. This can happen if the application has
//not been installed by the administrator of the tenant or consented to by any user in the tenant.You may have sent your authentication request to the wrong tenant.
//tennant ID 82dc4196-9dae-4650-9555-05bccddbfd01
////client id for FsrBuildTool: b14a83d2-dcc3-44c0-862e-83d3eb30cb34
